// extracted by mini-css-extract-plugin
module.exports = {"styles":"styles___2GMpw","content":"content___3PYwF","header":"header___1ynVW","body":"body___3V34F","bottom":"bottom___VQKqF","errorTip":"errorTip___NvZcM"};